import safeNumberConversion from "../../../utils/safeNumberConversion";
import sanitizeColumnName from "../../../utils/sanitizeColumnName";
import limitArraySize from "../../../utils/limitArraySize";

const fullyNormalized = (data) => data?.map((row) => {
  const normalized = { ...row };
  if (!normalized.status) normalized.status = "Pending"; // Default to legacy format

  // Populate dynamic columns from paid check history if available (loaded on demand)
  if (row.paid_check_history && Array.isArray(row.paid_check_history) && row.paid_check_history.length > 0) {
    const latestPaidCheck = [...row.paid_check_history].sort(
      (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
    )[0]; // Most recent
    const apiData = latestPaidCheck?.raw_data;

    if (apiData?.audienceAnalysis) {
      // Individual country percentages
      const countryArray = apiData.audienceAnalysis.countryArray || [];

      countryArray.forEach((item) => {
        if (item.country && item.value !== undefined) {
          const columnName = `country_${sanitizeColumnName(item.country)}`;
          normalized[columnName] = safeNumberConversion(item.value);
        }
      });

      // Individual language percentages
      const languageArray = apiData.audienceAnalysis.languageArray || [];
      languageArray.forEach((item) => {
        if (item.language && item.value !== undefined) {
          const columnName = `language_${sanitizeColumnName(item.language)}`;
          normalized[columnName] = safeNumberConversion(item.value);
        }
      });

      // Additional audience insights (limit array size for performance)
      normalized.audience_cities_full = JSON.stringify(
        limitArraySize(apiData.audienceAnalysis.cityArray || [], 50)
      );
      normalized.audience_countries_full = JSON.stringify(
        limitArraySize(apiData.audienceAnalysis.countryArray || [], 50)
      );
      normalized.audience_languages_full = JSON.stringify(
        limitArraySize(apiData.audienceAnalysis.languageArray || [], 50)
      );
      normalized.audience_interests_full = JSON.stringify(
        limitArraySize(apiData.audienceAnalysis.mentions || [], 100)
      );

      // Age demographics
      const ageArray =
        apiData.audienceAnalysis.averageBirthyearArray || [];
      const ageData13_17 = ageArray.find(
        (item) => item.birthyear === "13-17"
      );
      normalized.audience_age_13_17 = safeNumberConversion(
        ageData13_17?.value
      );

      const ageData18_24 = ageArray.find(
        (item) => item.birthyear === "18-24"
      );
      normalized.audience_age_18_24 = safeNumberConversion(
        ageData18_24?.value
      );

      const ageData25_34 = ageArray.find(
        (item) => item.birthyear === "25-34"
      );
      normalized.audience_age_25_34 = safeNumberConversion(
        ageData25_34?.value
      );

      const ageData35_44 = ageArray.find(
        (item) => item.birthyear === "35-44"
      );
      normalized.audience_age_35_44 = safeNumberConversion(
        ageData35_44?.value
      );

      const age45_54 = ageArray.find(
        (item) => item.birthyear === "45-54"
      );
      const age55_plus = ageArray.find(
        (item) => item.birthyear === "55+"
      );
      const val45_54 = safeNumberConversion(age45_54?.value) || 0;
      const val55_plus = safeNumberConversion(age55_plus?.value) || 0;
      const totalAge45Plus = val45_54 + val55_plus;
      normalized.audience_age_45_plus =
        totalAge45Plus > 0 ? totalAge45Plus : null;
    }
  }

  return normalized;
});

export default fullyNormalized;